import { render, staticRenderFns } from "./BacklinksListSelectionPopup.vue?vue&type=template&id=663d3791&scoped=true"
import script from "./BacklinksListSelectionPopup.vue?vue&type=script&lang=js"
export * from "./BacklinksListSelectionPopup.vue?vue&type=script&lang=js"
import style0 from "./BacklinksListSelectionPopup.vue?vue&type=style&index=0&id=663d3791&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "663d3791",
  null
  
)

export default component.exports